import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  notificationContainer: {
    padding: theme.spacing(0),
    maxWidth: '400px',
  },
  notificationItem: {
    padding: theme.spacing(2),
    transition: 'background-color 0.3s',
  },
  notificationBody: {
    fontSize: '11px',
  },
  notificationDate: {
    fontSize: '11px',
    marginTop: '3px',
    marginLeft: '4px',
  },
  notificationContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '340px',
  },
  notificationText: {
    flex: 1,
    color: 'white',
  },
  notificationTitle: {
    fontWeight: 'bold',
    color: 'white',
  },
  notificationTitleContainer: {
    display: '-webkit-box',
    alignItems: 'normal',
  },
  notificationMenu: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  readCircle: {
    color: 'white', // Color gris tenue
    marginTop: theme.spacing(0.5), // Espaciado debajo del menú
    cursor: 'pointer',
  },
  notificationMenuContainer: {
    display: 'flex',
    flexDirection: 'column', // Alinear los botones verticalmente
    alignItems: 'center',
    justifyContent: 'space-between', // Espacio entre el menú y el círculo
  },
  menuButton: {
    color: 'white',
    marginBottom: theme.spacing(1), // Espaciado entre el menú y el círculo
  },
  tab: {
    fontSize: '12px',
  },
  commentIcon: {
    fontSize: '20px',
    marginRight: '4px',
  },
  locationIcon: {
    fontSize: '15px',
    marginRight: '1px',
  },
}));

export default useStyles;
